import {convertPatternToValue} from './convertPatternToValue.js';
import KeyScaling from './KeyScaling.js';
import {convertValue} from './convertPatternToValue.js';
import Automations from './Automations.js';

export default superclass => class extends superclass  {
    fromJson(json, sequencerEngine, isCopy=false) {
        let oldId = this.id;
        if (json  === undefined) {
            return;
        }
        let bulk = {};

        if (json.id && !isCopy) {
            this.id = json.id;
            if (this.sequencerEngine) {
                this.sequencerEngine.idToParameter[this.id] = this;
            }
        }

        let subSequence = sequencerEngine !== undefined ?
            sequencerEngine.currentSubSequence || sequencerEngine.subSequences[0] : 
            undefined;

        if (json.lfo !== undefined) {
            this.enableAudioParam();
            this.connectToLFO(sequencerEngine.lfos[0].lfo);
        } else if (subSequence && json.lfos !== undefined && json.lfos.length > 0) {
            this.enableAudioParam();
            for (let i in json.lfos) {
                let lfo = json.lfos[i];
                if (this.lfos.includes(lfo)) {
                    // its already connected but id might have changed
                    lfo.replaceParameterIds(oldId, this.id, this);
                }
                this.connectToLFO(subSequence.lfos[lfo].lfo);
            }
        }

        if (subSequence && json.envelopes !== undefined && json.envelopes.length > 0) {
            this.enableAudioParam();
            json.envelopes.forEach(
                i => {
                    let env = subSequence.envelopes[i];
                    if (this.envelopes.includes(env)) {
                        env.replaceParameterIds(oldId, this.id, this);
                    } else
                    this.connectToEnvelope(env);
                });
        }

        if (json.value !== undefined) {
            bulk = this.set(json.value, true, true);
        }
        
        if (json.patternToValue !== undefined) {
            this.unlockedValue = json.unlockedValue !== undefined ?
                this.convertValue(json.unlockedValue) : this.value;
            this.patternToValue = convertPatternToValue(json.patternToValue);
            if (this.isPatternLocked() && this.patternToValue[0] !== undefined) {
                bulk = this.set(this.patternToValue[0], true, true);
            } else if (this.unlockedValue !== undefined) {
                bulk = this.set(this.unlockedValue, true, true);
            }
        }

        if (json.paletteToValue !== undefined) {
            this.paletteToValue = convertPatternToValue(json.paletteToValue);
        }

        if (json.patternToAutomation) {
            for (let i in json.patternToAutomation) {
                this.patternToAutomation[i] = new Automations(this);
                this.patternToAutomation[i].fromJson(json.patternToAutomation[i], false);
            }
            this.unlockedAutomation.fromJson(json.unlockedAutomation, false);
            if (this.isPatternLocked() && this.patternToAutomation[0]) {
                this.patternToAutomation[0].schedule();
            } else {
                this.automation.schedule();
            }
        }

        if (json.mixAutomation) {
            this.mixAutomation.fromJson(json.mixAutomation, false);
        }

        if (json.keyScaling) {
            this.keyScaling = new KeyScaling(this, json.keyScaling.min, json.keyScaling.max);
        }


        if (json.depth !== undefined) {
            if (!this.depthParameter) {
                this.initDepth();
            }
            this.depthParameter.fromJson(json.depth, sequencerEngine, isCopy);
        } else if (json._depth !== undefined) {
            this._depth = json._depth;
        }

        this.loadModsFromJson(json);

        let b = {};
        if (bulk === undefined) {
            return b;
        }
        b[bulk.id] = bulk.value;

        if (json.min !== undefined) {
            this.min = json.min;
        }

        if (json.max !== undefined) {
            this.max = json.max;
        }

        if (json.stepToValue) {
            this.stepToValue = json.stepToValue;
        }

        return b;
   }

    convertValue(v) {
        return convertValue(v);
    }

    getPresetValue() {
        if (this.currentPattern in this.patternToValue) {
            return this.patternToValue[this.currentPattern];
        }
        return this.unlockedValue;
    }

    getJson(isPreset=false) {
        let lfos = [];
        let envelopes = [];
        let mods = this.parameterMods;
        let subSequence = this.context === undefined ? undefined : this.context.subSequence;
        let patternToAutomation = {};
        for (let i in this.patternToAutomation) {
            patternToAutomation[i] = this.patternToAutomation[i].getJson();
        }
        return {
            id: this.id,
            unlockedAutomation: this.unlockedAutomation.getJson(),
            patternToAutomation,
            context: this.context === undefined ? undefined : this.context.getJson(),
            subSequence: subSequence === undefined ? undefined: subSequence.id,
            name: this.name,
            min: this.min,
            max: this.max,
            unlockedValue: isPreset ? this.getPresetValue() : this.unlockedValue,
            patternToValue: isPreset ? {} : this.patternToValue,
            paletteToValue: this.paletteToValue,
            originalMin: this.originalMin,
            originalMax: this.originalMax,
            mods: mods.map(mod => mod.getJson()),
            lfos: this.lfos.map(lfo => lfo.number - 1),
            envelopes: this.envelopes.map(env => env.number - 1),
            keyScaling: this.keyScaling ? this.keyScaling.getJson() : undefined,
            depth: this.depthParameter && this.depthParameter.getJson(isPreset),
            _depth: this._depth,
            mixAutomation: this.mixAutomation.getJson(),
            stepToValue: {... this.stepToValue}
        };
   }
}
